// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ThemeType {
    export type Type = 'light' | 'dark' | 'system'
    export enum Enum {
        LIGHT = 'light',
        DARK = 'dark',
        SYSTEM = 'system',
    }
    export const darkClassName = 'dark'
}
